import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const EmployeeManagement = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Çalışan Yönetimi
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Çalışan yönetimi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default EmployeeManagement;
